import React, { useState, useEffect } from "react";
import AdminHeader from "./AdminHeader";
import AdminNavigation from "./AdminNavigation";
import AdminFooter from "./AdminFooter";
import { Link } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";
import { ToastContainer, toast } from "react-toastify";
import {
  getParticipantGroupList,
  deleteData,
  getSiteListByManufacturerID,
  getMultipleManufacturerList,
} from "../../Utils/adminFunctions";
import { getDataArr } from "../../Utils/commonFunctions";
import dataTableGrid from "../DataTableGrid";

const AdminListParticipantGroups = () => {
  const [listParticipantGroups, setListParticipantGroups] = useState([]);
  const [listCompanies, setListCompanies] = useState([]);
  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const [listSites, setListSites] = useState([]);
  const [selectedSites, setSelectedSites] = useState([]);
  useEffect(() => {
    manageParticipantsGroup();
    getManufacturerList();
  }, []);
  const manageParticipantsGroup = async () => {
    let selectedCompaniesArr = getDataArr(selectedCompanies);
    let selectedSitesArr = getDataArr(selectedSites);
    let bodyFormData = new FormData();
    bodyFormData.append("manufacturer_ids", selectedCompaniesArr);
    bodyFormData.append("site_ids", selectedSitesArr);
    const response = await getParticipantGroupList(bodyFormData);
    if (response.status === "success" || response.status === "failure") {
      setListParticipantGroups(response.optionItems);
      dataTableGrid({
        data_table_id: "#group_list",
        paginate: false,
        copy_option: [0, 1, 2, 3, 4, 5],
        csv_option: [0, 1, 2, 3, 4, 5],
        print_option: [0, 1, 2, 3, 4, 5],
        sort_option: [6],
      });
    } else {
      toast.error(response, { autoClose: 1500 });
    }
  };
  const getManufacturerList = async () => {
    const response = await getMultipleManufacturerList();
    if (response.status === "success") {
      setListCompanies(response.optionItems);
    } else {
      setListCompanies([]);
    }
  };
  const handlePGDeleteRecord = async () => {
    let pgID = document.getElementById("deleteParticipantGroup").value;
    const response = await deleteData(pgID, "PARTICIPANTGROUP");
    if (response.status == "success") {
      manageParticipantsGroup();
      toast.success(response.message, { autoClose: 1500 });
      document.getElementById("close_modal").click();
    } else {
      toast.warning(response.message, { autoClose: 1500 });
      document.getElementById("close_modal").click();
    }
  };

  let filterParticipantGroup = () => {
    if (selectedCompanies.length == 0) {
      return false;
    }
    manageParticipantsGroup();
  };

  let refreshParticipantGroup = () => {
    selectedCompanies.length = 0;
    selectedSites.length = 0;
    setListSites([]);
    setSelectedSites([]);
    setSelectedCompanies([]);
    manageParticipantsGroup();
  };

  const getSites = async (e) => {
    if (e.length === 0) {
      setListSites([]);
      setSelectedSites([]);
      return false;
    }
    let selectedCompaniesArr = getDataArr(e);
    let bodyFormData = new FormData();
    bodyFormData.append("manufacturer_ids", selectedCompaniesArr);
    const response = await getSiteListByManufacturerID(bodyFormData);
    if (response.status === "success") {
      setListSites(response.optionItems);
    } else {
      setListSites([]);
    }
  };

  return (
    <div>
      <div className="wrapper">
        <div className="modal fade show" id="modal-default" arial-modal="true">
          <input type="hidden" id="deleteParticipantGroup" value=""></input>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Confirm delete</h4>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="close_modal"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this record?</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  data-dismiss="modal"
                  className="btn btn-sm btn-dark"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-danger"
                  onClick={() => handlePGDeleteRecord()}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
        <div>
          <ToastContainer />
          <AdminHeader />
          <AdminNavigation />
          <div className="content-wrapper">
            <div className="content-header"></div>
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-header">
                        <div className="row">
                          <div className="col-md-3">
                            <MultiSelect
                              placeholder="Select24"
                              options={listCompanies}
                              value={selectedCompanies}
                              onChange={(e) => {
                                getSites(e);
                                setSelectedCompanies(e);
                              }}
                            />
                          </div>

                          <div className="col-md-3">
                            <MultiSelect
                              options={listSites}
                              value={selectedSites}
                              onChange={(e) => {
                                setSelectedSites(e);
                              }}
                              labelledBy="Select"
                            />
                          </div>

                          <div className="col-md-3">
                            <button
                              className="btn btn-sm btn-warning"
                              onClick={() => filterParticipantGroup()}
                            >
                              <i className="fa fa-search" aria-hidden="true" />{" "}
                            </button>
                            &nbsp;
                            <button
                              className="btn btn-sm btn-warning"
                              onClick={() => refreshParticipantGroup()}
                            >
                              <i className="fa fa-refresh" aria-hidden="true" />{" "}
                            </button>
                          </div>
                          <div className="col-md-3">
                            <h3 className="card-title card-header-link pull-right">
                              <Link
                                to="/AdminAddParticipantGroup"
                                className="custom-link-primary"
                              >
                                <b>+ Add Group</b>
                              </Link>
                            </h3>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <table
                          id="group_list"
                          className="table table-bordered table-striped"
                        >
                          <thead>
                            <tr>
                              <th>S. No.</th>
                              <th>Participant Group ID</th>
                              <th>Company Name</th>
                              <th>Site Name</th>
                              <th>No. of Participants</th>
                              <th>Created On</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>{listParticipantGroups}</tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <AdminFooter />
        </div>
      </div>
    </div>
  );
};

export default AdminListParticipantGroups;
